/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-23 16:49:01
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-15 13:28:42
 * @FilePath: /src/app/payment/components/CodeCoupon/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getDiscountCouponText } from '@/components/Coupon/handler';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { toast } from '@/components/Toast';
import { useImperativeHandle, useState } from 'react';
import EntranceM from './components/Entrance.m';
import EntrancePc from './components/Entrance.pc';

import { useStore } from '@/providers/app-store-provider';
import { useTranslations } from 'next-intl';
import { env } from '@/utils/env';

interface CouponProps {
  canUseLength: number;
  usableCouponList: any[];
  price: any;
  couponApply: (item: any) => void;
  codeApply: (code: string) => void;
  ref: React.RefObject<any>;
  applyCancel: () => void;
}

export default function CodeCoupon(props: CouponProps) {
  const { couponApply, codeApply, ref, applyCancel, price, canUseLength, usableCouponList } = props;

  // 使用类型断言解决类型不匹配的问题

  useImperativeHandle(ref, () => ({
    updateState(state: any) {
      if ('couponCode' in state) setCouponCode(state.couponCode);
      if ('applyLoading' in state) setApplyLoading(state.applyLoading);
      if ('checkCoupon' in state) setCheckCoupon(state.checkCoupon);
      if ('couponCodeText' in state) setCouponCodeText(state.couponCodeText);
      if ('applyFlag' in state) setApplyFlag(state.applyFlag);
    },
    uploadCouponText,
  }));

  const t = useTranslations('coupons');
  const [couponCode, setCouponCode] = useState('');
  const [applyLoading, setApplyLoading] = useState(false);
  const [checkCoupon, setCheckCoupon] = useState(false); // 是否已经应用
  const [couponCodeText, setCouponCodeText] = useState('');
  const currencyList = useStore((state) => state.currencyList);
  const currency = currencyList.find((item) => item.name === env.NEXT_PUBLIC_DEFAULT_CURRENCY);

  // 用来管理在移动端是否需要关闭弹窗
  const [applyFlag, setApplyFlag] = useState(false);

  // 优惠码应用
  const handleCodeApply = () => {
    if (!couponCode) {
      // 显示错误消息
      toast.error(t('pleaseEnterCouponCode'));
      return false;
    }
    setApplyLoading(true);
    codeApply(couponCode);
  };

  // 取消优惠码
  const handleCodeCancel = () => {
    setApplyLoading(true);
    applyCancel();
  };

  const uploadCouponText = (coupon: any) => {
    const couponText = getDiscountCouponText(coupon.discount_code, t, currency);
    setCouponCodeText(couponText);
  };

  const handleCouponApply = (paymentParams: any) => {
    couponApply(paymentParams);
  };

  return (
    <div className="bg-white rounded-[10px] md:rounded-[5px] w-full py-[18px] px-[1.5625vw] mb-[12px] mt-10">
      <WebOnly>
        <EntrancePc
          canUseLength={canUseLength}
          couponCode={couponCode}
          checkCoupon={checkCoupon}
          applyLoading={applyLoading}
          handleCodeApply={handleCodeApply}
          handleCodeCancel={handleCodeCancel}
          onChangeCouponCode={setCouponCode}
          usableCouponList={usableCouponList}
          handleCouponApply={handleCouponApply}
          couponCodeText={couponCodeText}
        />
      </WebOnly>

      <WapOnly>
        <EntranceM
          price={price}
          applyFlag={applyFlag}
          canUseLength={canUseLength}
          couponCode={couponCode}
          checkCoupon={checkCoupon}
          applyLoading={applyLoading}
          handleCodeApply={handleCodeApply}
          handleCodeCancel={handleCodeCancel}
          onChangeCouponCode={setCouponCode}
          usableCouponList={usableCouponList}
          handleCouponApply={handleCouponApply}
          couponCodeText={couponCodeText}
          changeApplyFlag={() => setApplyFlag(false)}
        />
      </WapOnly>
    </div>
  );
}
